import React from "react";
import { Link } from "react-router-dom";
import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";
import { Button, Text, Title, Group, Stack } from "@mantine/core";
import { IconArrowLeft, IconHome } from "@tabler/icons-react";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />

      <div className="container mx-auto px-4 py-12 flex-grow flex items-center justify-center">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8 text-center">
          <Stack align="center">
            <div className="text-gray-400 text-8xl font-bold">404</div>

            <Title order={2} className="text-gray-800">
              Page Not Found
            </Title>

            <Text size="lg" className="mt-4 mb-6">
              The page you are looking for doesn't exist or has been moved.
            </Text>

            <Group>
              <Button
                component={Link}
                to="/"
                variant="outline"
                leftSection={<IconHome size={18} />}
                style={{
                  borderColor: "var(--accent-gold)",
                  color: "var(--accent-gold)",
                }}
                className="hover:bg-gray-50"
              >
                Back to Home
              </Button>
            </Group>
          </Stack>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NotFoundPage;
